/*
 * Action Types
 */
export enum DenyListTypes {
  LIST_DENYLIST_REQUEST = '@denylist/LIST_DENYLIST_REQUEST',
  LIST_DENYLIST_SUCCESS = '@denylist/LIST_DENYLIST_SUCCESS',
  LIST_DENYLIST_FAILURE = '@denylist/LIST_DENYLIST_FAILURE',

  GET_DENYLIST_REQUEST = '@denylist/GET_DENYLIST_REQUEST',
  GET_DENYLIST_SUCCESS = '@denylist/GET_DENYLIST_SUCCESS',
  GET_DENYLIST_FAILURE = '@denylist/GET_DENYLIST_FAILURE',

  CREATE_DENYLIST_REQUEST = '@denylist/CREATE_DENYLIST_REQUEST',
  CREATE_DENYLIST_SUCCESS = '@denylist/CREATE_DENYLIST_SUCCESS',
  CREATE_DENYLIST_FAILURE = '@denylist/CREATE_DENYLIST_FAILURE',
}

/*
 * Data types
 */
export interface DenyListInterface {
  id: string;
  status: number;
  reason: string;
  message: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  userId: string;
}

/*
 * State type
 */
export interface DenyListState {
  readonly denylistList: DenyListInterface[];
  readonly denylistData: DenyListInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
